<template>
  <div class="pageing" v-if="totalPage > 1">
    <img src="../assets/images/first.png" alt="第一页" class="firstPage" @click="changePage(1)" />
    <img class="prevPage" src="../assets/images/prev.png" alt="上一页" v-if="pageNo !==1" @click="changePage(pageNo-1)" />
    <div class="pageNum"><div class="l num now">{{pageNo}}</div><div class="l">/</div><div class="l num all">{{totalPage}}</div></div>
    <img src="../assets/images/next.png" alt="下一页" class="next" v-if="pageNo !==totalPage" @click="changePage(Number(pageNo)+1)" />
    <!--<img src="../assets/images/last.png" alt="最后一页" class="lastPage" @click="changePage(totalPage)" />-->
    <!--<div class="input">-->
      <!--<inputc class="textCenter" v-model="pageNumber" replace="money" />-->
    <!--</div>-->
    <!--<div class="make" @click="changePage(pageNumber)">确定</div>-->
  </div>
</template>

<script>
  import Input from '../components/input.vue'
  export default {
    name: 'minPage',
    components: {
      inputc: Input
    },
    props: ['totalPage', 'nowPage'],
    data() {
      return {
        pageNo: Number(this.nowPage) || 1,
        pageNumber:''
      }
    },
    watch: {
      nowPage: function () {
        this.pageNo = Number(this.nowPage)
      }
    },

    methods: {
      changePage(n) {
        if(n==''||n==null|| n<=0) return;
        if(n===this.pageNo) return;
        this.pageNo = Number(n)>Number(this.totalPage)?Number(this.totalPage):Number(n);
        this.$emit('changePage',this.pageNo)
      }
    }
  }
</script>

<style lang="sass" scoped>
  %vertical
    vertical-align: middle
    display: inline-block
    margin-right: 20px

  .pageing
    min-width: 290px
    height: 30px
    line-height: 30px
    font-size: 0

  .firstPage, .prevPage, .next, .lastPage
    width: 12px
    height: 14px
    cursor: pointer
    @extend %vertical
  .prevPage
    margin-right: 25px
  .firstPage
    margin-right: 25px
  .pageNum
    font-size: 14px
    @extend %vertical
    margin-right: 25px
    /*.num*/
      /*width: 25px*/
    /*.now*/
      /*text-align: right*/
  .input
    width: 60px
    height: 30px
    @extend %vertical

  .make
    color: #666666
    cursor: pointer
    font-size: 14px
    @extend %vertical
    margin-right: 0
</style>
